<template>
	<div class="beta-features">
		<ul class="results-list results-list--beta-features" :variant="variant">
			<li
				:id="`${uid}_${index}`"
				class="results-list__item"
				:key="item.id"
				v-for="(item, index) in items"
			>
				<BetaFeaturesCard :source="item" />
			</li>
		</ul>
	</div>
</template>

<script>
import BetaFeaturesCard from './features-summary-card';

export default {
	name: 'BetaFeaturesList',
	components: {
		BetaFeaturesCard
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped></style>
